import {
	Box,
	Collapse,
	Grid,
	TextField,
	CircularProgress,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from 'react-intl';
import Switch from "react-switch";
import * as Utils from '../../commons/utils/Utils';

const FILTER_STATE_INIT = {
	id: '',
	fecha: '',
	tipoRelato: '',
	evento: '',
	base: '',
	transportadora: '',
	centroCostos: '',
	conductor:'',
	dominio: '',
	estado: '',
}

const QUERY_INIT = {
	id: '',
	fecha: '',
	tipoRelato: '',
	evento: '',
	base: '',
	transportadora: '',
	centroCostos: '',
	conductor:'',
	dominio: '',
	estado: 'PENDIENTE'
}

const getFilterStateInit = (intl) => {
	let filtersState = JSON.parse(JSON.stringify(FILTER_STATE_INIT));
	filtersState.estado = { label: intl.formatMessage({ id: "ReportesGridFilters.render.filtros_estado.opciones.pendientes", defaultMessage: "Pendientes" }), value: 'PENDIENTE' };
	return filtersState;
}

const handleInitFilters = (intl) => {
	let filterInit = getFilterStateInit(intl)
	let storage = JSON.parse(window.localStorage.getItem('SafeFeedbackReportesGridFilter'))
	if(storage && storage.activo && storage.filtros){
		filterInit = storage.filtros
	}
	return filterInit
}

const ReportesGridFilters = (props) => {
	const intl = useIntl();

	const [init,setInit] = useState(false)
	const [filtersLoading, setFiltersLoading] = useState(false);
	const [filtersState, setFiltersState] = useState(handleInitFilters(intl));
	const [bases, setBases] = useState([]);
	const [transportadoras, setTransportadoras] = useState([]);
	const [centrosCostos, setCentrosCostos] = useState([]);

	const [validatorSearch, setValidatorSearch] = useState(false)
	const estados = [
		{ label: intl.formatMessage({ id: "ReportesGridFilters.render.filtros_estado.opciones.todos", defaultMessage: "Todos" }), value: '' },
		{ label: intl.formatMessage({ id: "ReportesGridFilters.render.filtros_estado.opciones.pendientes", defaultMessage: "Pendientes" }), value: 'PENDIENTE' },
		{ label: intl.formatMessage({ id: "ReportesGridFilters.render.filtros_estado.opciones.confirmados", defaultMessage: "Confirmados" }), value: 'CONFIRMADO' },
		{ label: intl.formatMessage({ id: "ReportesGridFilters.render.filtros_estado.opciones.desestimados", defaultMessage: "Desestimados" }), value: 'DESESTIMADO' },
	]

	useEffect(() => {
		fetchData()
		initFilter()
	}, []);

	useEffect(() => {
		if(props.filterResetInputs){
			setFiltersState(JSON.parse(JSON.stringify(getFilterStateInit(intl))));
			window.localStorage.setItem('SafeFeedbackReportesGridFilter',JSON.stringify({activo: false, filtros: getFilterStateInit(intl)}));
		}
	},[props.filterResetInputs])

	useEffect(() => {
		!props.dropdownActive && props.setFilterResetInputs(false)
		!props.dropdownActive && setFiltersLoading(false)
	}, [props.dropdownActive]);

	useEffect(() => {
		if(props.filterKpi){
			filtersState.id = ''
			filtersState.fecha = ''
			filtersState.tipoRelato = ''
			filtersState.evento = ''
			filtersState.base = ''
			filtersState.dominio = ''
			filtersState.conductor = ''
			filtersState.estado = estados.find((estado) => estado.value === props.filterKpi)
			persistentFilter(true);
			props.handleFilterChange();
			props.setSearchActive(true)
			let query = queryTable();
			props.setFilterQuery(query);
		}
	}, [props.filterKpi]);

	const fetchData = () => {
		setFiltersLoading(true)

		const basesReq = Utils.getData('/bases/select-filtered-by-user')
			.then((responseBases) => {
				setBases(responseBases || []);
			})
			.catch((err) => {
				console.log(err);
			});

		let transportadorasReq = Promise.resolve();
		let centrosCostosReq = Promise.resolve();

		if (props.transportadoraGrilla) {
			transportadorasReq = Utils.getData('/transportadoras/select')
				.then((responseTransportadoras) => {
					setTransportadoras(responseTransportadoras || []);
				})
				.catch((err) => {
					console.log(err);
				});

			centrosCostosReq = Utils.getData('/centros-costos/select')
				.then((responseCentrosCostos) => {
					setCentrosCostos(responseCentrosCostos || []);
				})
				.catch((err) => {
					console.log(err);
				});
		}

		Promise.all([basesReq, transportadorasReq, centrosCostosReq])
			.finally(() => {
				setFiltersLoading(false);
			});
	}

	const onChangePersistentFilter = (value) => {
		window.localStorage.setItem('SafeFeedbackReportesGridFilter', JSON.stringify({activo: value, filtros: filtersState}));
		props.setPersisteFiltros(value)
	}

	const initFilter = () => {
		setFiltersLoading(true);
		let query = {}

		if(props.persisteFiltros || validatorNotNull()){
			props.setSearchActive(true);
		}
		
		query = queryTable();
		
		setInit(true)
		
		window.localStorage.setItem('SafeFeedbackReportesGridFilter',JSON.stringify({activo: props.persisteFiltros, filtros: filtersState}));
		props.setFilterQuery(query);
		setFiltersLoading(false)
		return;
	}

	const queryTable = () => {
		let query = {}
		query = JSON.parse(JSON.stringify(filtersState));
		query['id'] = filtersState.id ? filtersState.id : ''
		query['fecha'] = filtersState.fecha ? filtersState.fecha : ''
		query['tipoRelato'] = filtersState.tipoRelato ? filtersState.tipoRelato : ''
		query['evento'] = filtersState.evento ? filtersState.evento : ''
		query['base'] = filtersState.base ? filtersState.base.value : ''
		query['transportadora'] = filtersState.transportadora ? filtersState.transportadora.id : ''
		query['centroCostos'] = filtersState.centroCostos ? (filtersState.centroCostos.id || filtersState.centroCostos.value) : ''
		query['dominio'] = filtersState.dominio ? filtersState.dominio : ''
		query['conductor'] = filtersState.conductor ? filtersState.conductor : ''
		query['estado'] = filtersState.estado ? filtersState.estado.value : ''
		return query;
	}

	useEffect(() => {
		if(init){
			if(props.persisteFiltros){
				window.localStorage.setItem('SafeFeedbackReportesGridFilter', JSON.stringify({activo: true, filtros: filtersState}));
			}
			else{
				setFiltersState(JSON.parse(JSON.stringify(getFilterStateInit(intl))));
				props.setFilterQuery(JSON.parse(JSON.stringify(QUERY_INIT)));
				window.localStorage.setItem('SafeFeedbackReportesGridFilter',JSON.stringify({activo: false, filtros: getFilterStateInit(intl)}));
			} 
		}
	},[props.persisteFiltros])

	useEffect(() => {
		setValidatorSearch(validator());
	},[filtersState])

	const validator = () => {
		var result = Object.entries(filtersState);
		for (var index in result){
			if(Array.isArray(result[index][1])){
				if(result[index][1].length > 0 ){
					return false
				}
			}else{
				if(result[index][1]){
					return false
				}
			}
		}
		return true
	}

	const validatorNotNull = () => {
		var result = Object.entries(filtersState);
		for (var index in result){
			if(result[index] && result[index][0]==='estado'){
				if(result[index][1] && result[index][1].value === 'PENDIENTE'){
					continue
				}
			}
			if(Array.isArray(result[index][1])){
				if(result[index][1].length > 0){
					return true
				}
			}else{
				if(result[index][1]){
					return true
				}
			}
		}
		return false
	}

	const handleSubmitInto = (event) => {
		if(!props.loading && !validatorSearch){
			handleSubmit(event);
		}
		event.preventDefault();
	}

	const persistentFilter = (value) => {
		if (props.persisteFiltros) {
			window.localStorage.setItem('SafeFeedbackReportesGridFilter', JSON.stringify({activo: value, filtros: filtersState}));
		}
	}

	const handleSubmit = (event) => {
		persistentFilter(true);
		props.handleFilterChange();
		event.preventDefault();
		props.setSearchActive(true)
		let query = queryTable();
		props.setFilterQuery(query);
		return;
	}

	const handleChange = (name, object) => {
		setFiltersState((prevState) => {
			const updatedFiltersState = { ...prevState, [name]: object };                
			return updatedFiltersState;
		});
  	};

	return (
		<>
			{init &&
				<Collapse in={props.dropdownActive}>
					<Grid container item xs={12} spacing={3} style={{marginBottom:20}}>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<Autocomplete
									size="small"
									name="estado"
									options={estados}
									value={filtersState.estado}
									defaultValue={null}
									getOptionLabel={(option) => option ? option.label : ""}
									onChange={(e, value) => handleChange('estado', value)}
									renderInput={(params) => (
									<TextField {...params} variant="standard"
										label={intl.formatMessage({ id: "ReportesGridFilters.render.filtros_estado.label", defaultMessage: "Estado" })}
										placeholder={intl.formatMessage({ id: "ReportesGridFilters.render.filtros_estado.placeholder", defaultMessage: "Estado" })}
										InputProps={{
										...params.InputProps,
										endAdornment: (
											<React.Fragment>
											{params.InputProps.endAdornment}
											</React.Fragment>
										),
										}}
									/>
									)}
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({
										id: 'ReportesGridFilters.render.filtros_fecha.label',
										defaultMessage: 'Fecha',
									})}
									name="fecha"
									value={filtersState.fecha}
									onChange={(e) => {handleChange('fecha', e.target.value)}}
									className="col-12"
									type="date"
									format={'DD-MM-YYYY'}
									InputLabelProps={{
										shrink: true,
									}}
								/>
							</form>
						</Grid>
						{props.transportadoraGrilla && (
							<Grid component={Box} item xs={3}>
								<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
									<Autocomplete
										size="small"
										name="transportadora"
										options={transportadoras}
										value={filtersState.transportadora}
										defaultValue={null}
										getOptionLabel={(option) => option ? option.nombre : ""}
										onChange={(e, value) => handleChange('transportadora', value)}
										renderInput={(params) => (
										<TextField {...params} variant="standard"
											label={intl.formatMessage({ id: "DisponibilidadGridFilters.render.filtros_transportadora.label", defaultMessage: "Transportadora" })}
											placeholder={intl.formatMessage({ id: "DisponibilidadGridFilters.render.filtros_transportadora.placeholder", defaultMessage: "Transportadora" })}
											InputProps={{
											...params.InputProps,
											endAdornment: (
											<React.Fragment>
												{filtersLoading ? (
													<CircularProgress color="inherit" size={21} />
												) : null}
												{params.InputProps.endAdornment}
											</React.Fragment>
											),
											}}
										/>
										)}
									/>
								</form>
							</Grid>
						)}
						{props.transportadoraGrilla && (
							<Grid component={Box} item xs={3}>
								<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
									<Autocomplete
										size="small"
										name="centroCostos"
										options={centrosCostos}
										value={filtersState.centroCostos}
										defaultValue={null}
										getOptionLabel={(option) => option ? option.label : ""}
										onChange={(e, value) => handleChange('centroCostos', value)}
										renderInput={(params) => (
										<TextField {...params} variant="standard"
											label={intl.formatMessage({ id: "movilesGrid.render.filtros_centroCosto.label", defaultMessage: "Centro de Costos" })}
											placeholder={intl.formatMessage({ id: "movilesGrid.render.filtros_centroCosto.placeholder", defaultMessage: "Centro de Costos" })}
											InputProps={{
											...params.InputProps,
											endAdornment: (
											<React.Fragment>
												{filtersLoading ? (
													<CircularProgress color="inherit" size={21} />
												) : null}
												{params.InputProps.endAdornment}
											</React.Fragment>
											),
											}}
										/>
										)}
									/>
								</form>
							</Grid>
						)}
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({
										id: 'ReportesGridFilters.render.filtros_tipo_relato.label',
										defaultMessage: 'Tipo de Relato',
									})}
									name="tipoRelato"
									value={filtersState.tipoRelato}
									onChange={(e) => {handleChange('tipoRelato', e.target.value)}}
									className="col-12"
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({
										id: 'ReportesGridFilters.render.filtros_evento.label',
										defaultMessage: 'Evento',
									})}
									name="evento"
									value={filtersState.evento}
									onChange={(e) => {handleChange('evento', e.target.value)}}
									className="col-12"
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<Autocomplete
									size="small"
									name="base"
									options={bases}
									value={filtersState.base}
									defaultValue={null}
									getOptionLabel={(option) => option ? option.label : ""}
									onChange={(e, value) => handleChange('base', value)}
									renderInput={(params) => (
									<TextField {...params} variant="standard"
										label={intl.formatMessage({ id: "movilesGrid.render.filtros_base.label", defaultMessage: "Base" })}
										placeholder={intl.formatMessage({ id: "movilesGrid.render.filtros_base.placeholder", defaultMessage: "Base" })}
										InputProps={{
										...params.InputProps,
										endAdornment: (
										<React.Fragment>
											<CircularProgress
												color="inherit"
												size={21}
												style={{ display: bases.length === 0 ? 'inline-block' : 'none' }}
											/>
											{params.InputProps.endAdornment}
										</React.Fragment>
										),
										}}
									/>
									)}
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({
										id: 'ReportesGridFilters.render.filtros_placa.label',
										defaultMessage: 'Placa',
									})}
									name="dominio"
									value={filtersState.dominio}
									onChange={(e) => {handleChange('dominio', e.target.value)}}
									className="col-12"
								/>
							</form>
						</Grid>
						<Grid component={Box} item xs={3}>
							<form noValidate autoComplete="off" onSubmit={handleSubmitInto}>
								<TextField
									label={intl.formatMessage({
										id: 'ReportesGridFilters.render.filtros_conductor.label',
										defaultMessage: 'Conductor',
									})}
									name="conductor"
									value={filtersState.conductor}
									onChange={(e) => {handleChange('conductor', e.target.value)}}
									className="col-12"
								/>
							</form>
						</Grid>
						<Grid
							xs={12}
							container
							justifyContent="space-between"
							alignItems="center"
							flexDirection={{ xs: 'column', sm: 'row' }}
							sx={{ fontSize: '12px' }}
						>
							<Grid component={Box} item xs={2} className="align-self-end">
								<div className="d-flex inline justify-content-around align-items-center">
									<FormattedMessage
										id="ReportesGridFilters.render.filtros.persistir_filtros"
										defaultMessage="Persistir Filtros"
									/>
									<Switch
										onChange={(value) => onChangePersistentFilter(value)}
										checked={props.persisteFiltros}
										disabled={filtersLoading}
										offColor="#FF4961"
										onColor="#28D094"
									/>
								</div>
							</Grid>
							<Grid component={Box} item xs={1} className="align-self-end"
							>
								<button
									disabled={props.loading || validatorSearch}
									className="btn btn-primary mr-1"
									onClick={(e) => handleSubmit(e)}
								>
									<i className="fa fa-search fa-xs"></i>   <FormattedMessage id="Buscar" defaultMessage="Buscar"/>
								</button>
							</Grid>
							</Grid>
					</Grid>
				</Collapse>
			}
		</>
	)
}

export default ReportesGridFilters

